import type { FooterTemplate } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';
import { useEffect } from 'react';
import { useFetcher, useMatch } from 'react-router';

import { ClientOnly } from '@jane/bloom/components/clientOnly';
import type { ImportedFooterTemplate } from '@jane/bloom/routes/api.footer/types';

import { ShadowFooter } from './footer/shadowFooter.client';
import { TemplatedFooter } from './footer/templatedFooter';

interface FooterProps {
  menuFooter?: Nullish<FooterTemplate>;
}

export const Footer = ({ menuFooter }: FooterProps) => {
  const fetcher = useFetcher<ImportedFooterTemplate>({
    key: 'footer-template',
  });
  const isCheckout = useMatch('/checkout');

  useEffect(() => {
    if (!fetcher.data && fetcher.state === 'idle' && !menuFooter?.enabled) {
      fetcher.load(`/api/footer`);
    }
  }, [fetcher, menuFooter?.enabled]);

  if (isCheckout) {
    return null;
  }

  if (menuFooter && menuFooter.enabled) {
    return <ClientOnly>{() => <TemplatedFooter {...menuFooter} />}</ClientOnly>;
  }

  if (fetcher.data) {
    return <ClientOnly>{() => <ShadowFooter {...fetcher.data} />}</ClientOnly>;
  }

  return null;
};
